var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"grade-chart",class:_vm.heightClass},[_c('bar-chart',{attrs:{"data":_vm.chartData,"options":{
        responsive: true,
        maintainAspectRatio: false,
        legend: { display: false },
        scales: {
          yAxes: [{
            ticks: {
              beginAtZero: true
            }
          }]
        }
      }}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }